import React from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Truck, ShieldCheck } from "lucide-react";

export default function Login() {
  const location = useLocation();
  const error = location.state?.error;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex bg-white">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-md w-full">
          <img
            src="/vivan-logo.jpg"
            alt="Vivan Paribahan"
            className="h-24 w-auto mb-6 object-contain"
            data-testid="login-logo"
          />
          <div className="label-eyebrow">Fleet Operations</div>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-2">
            Vivan Paribahan
          </h1>
          <p className="text-sm text-gray-500 mt-3 leading-relaxed">
            Daily ops, INR ledger, and fleet performance — for the registered
            owner only. Sign in with your Google account to continue.
          </p>

          {error && (
            <div
              className="mt-5 p-3 border border-red-200 bg-red-50 text-red-700 text-sm rounded-md"
              data-testid="login-error"
            >
              {error}
            </div>
          )}

          <Button
            onClick={handleLogin}
            className="mt-6 w-full h-11 gap-2 bg-black hover:bg-gray-800 text-white"
            data-testid="login-google-btn"
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="#FFFFFF"
                d="M21.6 12.227c0-.815-.073-1.6-.21-2.354H12v4.451h5.385a4.6 4.6 0 0 1-1.997 3.018v2.51h3.232c1.892-1.741 2.98-4.305 2.98-7.625Z"
              />
              <path
                fill="#FFFFFF"
                d="M12 22c2.7 0 4.964-.895 6.62-2.422l-3.232-2.51c-.895.6-2.04.954-3.388.954-2.605 0-4.81-1.76-5.598-4.124H3.064v2.59A9.996 9.996 0 0 0 12 22Z"
              />
              <path
                fill="#FFFFFF"
                d="M6.402 13.898a5.997 5.997 0 0 1 0-3.796V7.512H3.064a10 10 0 0 0 0 8.976l3.338-2.59Z"
              />
              <path
                fill="#FFFFFF"
                d="M12 5.978c1.469 0 2.786.505 3.823 1.498l2.866-2.866C16.96 2.99 14.696 2 12 2A9.996 9.996 0 0 0 3.064 7.512l3.338 2.59C7.19 7.738 9.395 5.978 12 5.978Z"
              />
            </svg>
            Sign in with Google
          </Button>

          <div className="mt-6 flex items-center gap-2 text-xs text-gray-500">
            <ShieldCheck className="h-3.5 w-3.5" />
            Restricted to the registered owner's email.
          </div>
        </div>
      </div>

      <div className="hidden lg:flex flex-1 items-center justify-center border-l border-gray-200 bg-gray-50">
        <div className="text-center px-8">
          <img
            src="/vivan-logo.jpg"
            alt="Vivan Paribahan"
            className="h-40 w-auto mx-auto object-contain"
          />
          <div className="label-eyebrow mt-6">Commercial Fleet</div>
          <p className="font-display text-2xl font-bold tracking-tight mt-2">
            Operations · Ledger · Reports
          </p>
        </div>
      </div>
    </div>
  );
}
